import React, { useState, useRef, useCallback } from 'react';
import { Box, Grid } from '@material-ui/core';
import GridContainer from '../../../@jumbo/components/GridContainer';

import SimpleDataCard from '../SharedComponents/SimpleDataCard';
import OcurrencesDataRenderV2 from '../SharedComponents/OcurrencesDataRenderV2';
import ocurrencesService from '../../../services/f5-services/ocurrencesService';

import FolderIcon from '@material-ui/icons/Folder';

const normalizePaginationResponse = (response, fallbackPage, fallbackPerPage) => {
    if (Array.isArray(response)) {
        return {
            data: response,
            total: response.length,
            currentPage: fallbackPage,
            perPage: fallbackPerPage,
        };
    }

    if (response && response.caixa && Array.isArray(response.caixa.data)) {
        return {
            data: response.caixa.data,
            total: typeof response.caixa.total === 'number' ? response.caixa.total : response.caixa.data.length,
            currentPage: typeof response.caixa.current_page === 'number' ? response.caixa.current_page : fallbackPage,
            perPage: typeof response.caixa.per_page === 'number' ? response.caixa.per_page : fallbackPerPage,
        };
    }

    if (response && Array.isArray(response.data)) {
        return {
            data: response.data,
            total: typeof response.total === 'number' ? response.total : response.data.length,
            currentPage: typeof response.current_page === 'number' ? response.current_page : fallbackPage,
            perPage: typeof response.per_page === 'number' ? response.per_page : fallbackPerPage,
        };
    }

    return {
        data: [],
        total: 0,
        currentPage: fallbackPage,
        perPage: fallbackPerPage,
    };
};

const CompletedOcurrences = () => {
    const [currentList, setCurrentList] = useState('completed');
    const [completedTotal, setCompletedTotal] = useState(0);
    const [error, setError] = useState('');
    const latestRequestRef = useRef(0);
    const completedTotalRef = useRef(0);

    const loadCompletedData = useCallback(async query => {
        const nextRequestId = latestRequestRef.current + 1;
        latestRequestRef.current = nextRequestId;

        const fallbackPage = query.page + 1;
        const fallbackPerPage = query.pageSize;
        const params = {
            page: fallbackPage,
            per_page: fallbackPerPage,
            search: query.search,
        };

        try {
            setError('');

            const response = await ocurrencesService.getCompletedOcurrencesPaginated(params);

            // Ignores stale responses when user changes page/search quickly.
            if (nextRequestId !== latestRequestRef.current) {
                return {
                    data: [],
                    page: query.page,
                    totalCount: completedTotalRef.current,
                };
            }

            const normalized = normalizePaginationResponse(response, fallbackPage, fallbackPerPage);
            setCompletedTotal(normalized.total);
            completedTotalRef.current = normalized.total;

            return {
                data: normalized.data.map(item => ({ ...item, id: item.ocorrencia_id })),
                page: normalized.currentPage > 0 ? normalized.currentPage - 1 : 0,
                totalCount: normalized.total,
            };
        } catch (err) {
            if (nextRequestId !== latestRequestRef.current) {
                return {
                    data: [],
                    page: query.page,
                    totalCount: completedTotalRef.current,
                };
            }

            setError('Não foi possível carregar as ocorrências finalizadas.');

            return {
                data: [],
                page: query.page,
                totalCount: 0,
            };
        }
    }, []);

    const ocurrencesData = {
        completed: {
            icon: <FolderIcon fontSize="large" />,
            label: 'Ocorrências Finalizadas',
            colors: ['#4a99ba', '#0c5c7d'],
            total: completedTotal,
        },
    };

    return (
        <GridContainer>
            <Grid item xs={12} sm={6} md={3}>
                <SimpleDataCard
                    label={ocurrencesData.completed.label}
                    icon={ocurrencesData.completed.icon}
                    colors={ocurrencesData.completed.colors}
                    value={ocurrencesData.completed.total}
                    setList={() => setCurrentList('completed')}
                />
            </Grid>
            <Grid item xs={12}>
                <OcurrencesDataRenderV2
                    bgcolor={ocurrencesData[currentList].colors[0]}
                    label={ocurrencesData[currentList].label}
                    icon={ocurrencesData[currentList].icon}
                    error={error}
                    loadData={loadCompletedData}
                    extraColumns={[
                        {
                            title: 'Tempo de resposta',
                            field: 'tempo_resposta',
                            render: rowData => (
                                <Box fontSize={12}>{rowData.tempo_resposta <= 0 ? '1' : rowData.tempo_resposta} Dia(s)</Box>
                            ),
                        },
                    ]}
                />
            </Grid>
        </GridContainer>
    );
};

export default CompletedOcurrences;
